import { render, staticRenderFns } from "./FactFindDependants.vue?vue&type=template&id=313fab34&"
import script from "./FactFindDependants.vue?vue&type=script&lang=ts&"
export * from "./FactFindDependants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports